import React from 'react'
import Calendar from './Calendar'
import Hours from './Hours'
import ButtonWithLoader from './ButtonWithLoader'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'

interface Props {
  toggleModal: () => void
}

const AddAvailabilityModal = ({ toggleModal }: Props) => {
  const selectedDay = useSelector((state: RootReducer) => state.timeSlotsReducer.selectedDay)

  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <div className="flex justify-center items-center">
          <Calendar />
        </div>
        <div className="h-2" />
        <div className="h-2" />
        <Hours />
        <div className="h-2" />
        <div className="px-6">
          {selectedDay.day ? (
            <ButtonWithLoader
              onClick={() => {
                toggleModal()
              }}
              label="Add Availability"
            />
          ) : (
            <div className="text-center text-sm text-gray-500">Select a day to add availability</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AddAvailabilityModal
